export default __webpack_public_path__ + "static/media/Prophecy_3x2_Cn.4e9878e1.webp";